{
    "grant_type":"client_credentials",
    "client_id":"dev-educate:default",
    "client_secret":"yd81pin3z6lxjv3csowguipchhtsdpzypnzrbw8xvrux",
    "scope":"squidex-api",
    "TokenUrl":"https://cms.ooki.io/identity-server/connect/token",
    "AllCategory":"https://cms.ooki.io/api/content/dev-educate/dev-educate/?$filter=data/RefCommonCategory/iv eq ",
    "Restcategory":"https://cms.ooki.io/api/content/dev-educate/dev-educate/?$filter=data/Category/iv eq ",
    "ArticleList":"https://cms.ooki.io/api/content/dev-educate/dev-educate/",
    "CategoryList":"https://cms.ooki.io/api/content/dev-educate/category/?$orderby=data/OrderNo/iv",
    "MostReadArticle":"https://cms.ooki.io/api/content/dev-educate/dev-educate?$filter=data/IsMostRead/iv eq true&$orderby=lastModified desc",
    "PriorityArticle":"https://cms.ooki.io/api/content/dev-educate/dev-educate?$filter=data/IsPriorityArticle/iv eq true&$orderby=lastModified desc",
    "ImgUrl":"https://cms.ooki.io/api/assets/",
    "DomainKey": "OOKI"
}
